import React, { useEffect, useState } from 'react';
import styles from '../App.module.css';
const Organize = () => {
  const [loading, setLoading] = useState(false);
  const [organize, setOrganize] = useState([]);
  const baseurl = process.env.REACT_APP_API_BASE_URL;
  const getOrganize = async() => {
    try {
      const response = await fetch(`${baseurl}get-organizer.php`);
      const result = await response.json();
      setOrganize(result.data); // Adjust based on your API response       
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {}
  };
  useEffect(()=>{
    getOrganize()
  },[])
  return (
    <>
    {
      loading ? (
        <div className="animate-pulse bg-slate-500 w-full">
          <div className="flex justify-between items-center p-0 py-4 h-full container">
              <div className="h-72 w-1/4 mx-2 bg-slate-500 pt-3">
                <div className="h-10 bg-gray-200 rounded dark:bg-slate-400 w-60 mb-2"></div>
                <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-60 mb-2"></div>
                <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-52 mb-2"></div>
                <div className="h-8 bg-gray-200 dark:bg-slate-400 w-24 mb-2"></div>
              </div>
              <div className="h-72 w-1/4 mx-2 rounded bg-slate-300 flex flex-col justify-end ps-3 pb-3">
                <div className="h-7 bg-gray-200 rounded dark:bg-slate-400 w-28 mb-2"></div>
                <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-52 mb-2"></div>
                <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-40 mb-2"></div>
              </div>
              <div className="h-72 w-1/4 mx-2 rounded bg-slate-300 flex flex-col justify-end ps-3 pb-3">
                <div className="h-7 bg-gray-200 rounded dark:bg-slate-400 w-28 mb-2"></div>
                <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-52 mb-2"></div>
                <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-40 mb-2"></div>
              </div>
              <div className="h-72 w-1/4 mx-2 rounded bg-slate-300 flex flex-col justify-end ps-3 pb-3">
                <div className="h-7 bg-gray-200 rounded dark:bg-slate-400 w-28 mb-2"></div>
                <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-52 mb-2"></div>
                <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-40 mb-2"></div>
              </div>
            </div>
        </div>
      ) :(
        <section id="organize" className="py-10 bg-dark">
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <h2 className="text-5xl font-bold uppercase text-white">Organize</h2>
                <p className='text-white text-xs mb-0'>We are nationally recognized event planning & organising company based in mumbai.</p>
                <button className="text-xs mt-6 p-2 px-3 uppercase border-yellow-400 border-1 text-black hover:text-white font-semibold hover:bg-transparent bg-yellow-400 transition duration-300">View all</button>
              </div>
              {
                organize.map((organ)=>
                  <div className="col-md-3" data-aos="fade-left">          
                    <div className={`${styles.organize_cards} shadow-lg text-white p-3`} style={{backgroundImage:`url(${organ.image})`}}>
                      <h3 className="text-1xl font-bold uppercase mb-0">{organ.event_type}
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className={`${styles.organize_arrow} bi bi-arrow-right-short`} viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"/>
                      </svg>
                      </h3>
                      <p className="text-l mb-0 leading-5">{organ.title}</p>
                    </div>
                  </div>
                )
              }                   
            </div>
          </div>
        </section>
      )
    }
    </>
  );
}

export default Organize;